var AppPagesEnum;
(function (AppPagesEnum) {
    AppPagesEnum["DASHBOARD"] = "DashboardPage";
    AppPagesEnum["API_KEY"] = "ApiKeyPage";
    AppPagesEnum["SLACK"] = "CredentialsPage";
    AppPagesEnum["ADMIN"] = "AdminPage";
})(AppPagesEnum || (AppPagesEnum = {}));
export default AppPagesEnum;
